import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
export default function UserView() {
  const history = useHistory();
  const [loading, setloading] = useState(true);
  const [users, setusers] = useState([]);
  const [CurrentuserID, setCurrentuserID] = useState("");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const changeAccess = (changeAccess) => {
    let data = {
      id: CurrentuserID,
      changeAccess: changeAccess,
    };
    axios.post("/api/update-user-access", data).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        fetchUsers();
      } else if (res.data.status === 222) {
        swal("Success", res.data.message, "success");
        logoutSubmit();
      } else if (res.data.status === 404) {
        history.push("/admin");
      }
    });
    setAnchorEl(null);
  };
  console.log(CurrentuserID, "CurrentuserID");

  useEffect(() => {
    document.title = "All Users";
    fetchUsers();
  }, [history]);

  const logoutSubmit = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/logout`).then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          sessionStorage.removeItem("auth_token");
          sessionStorage.removeItem("auth_name");
          sessionStorage.removeItem("role");

          swal("Success", res.data.message, "success");
          console.log(history, "history");
          history.replace("/");
        }
      });
    });
  };

  const fetchUsers = () => {
    axios.get(`/api/view-users`).then((res) => {
      if (res.data.status === 200) {
        console.log(res.data.data, "users");
        setusers(res.data.data);
      } else if (res.data.status === 205) {
        swal("ACCESS DENIED!", res.data.message, "error");
        history.push("/admin/dashboard");
      }
      setloading(false);
    });
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{ backgroundColor: "#bebd2d" }}>
            <TableCell>Id</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Account Created</TableCell>
            <TableCell>Change Access</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((data, index) => {
            let role = "";
            role =
              data.role_as == 1
                ? "Admin"
                : data.role_as == 2
                ? "Super Admin"
                : "Normal User";
            let UserID = data.id;
            return (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {data.id}
                </TableCell>
                <TableCell>{data.name}</TableCell>
                <TableCell>{data.email}</TableCell>
                <TableCell>{role}</TableCell>
                <TableCell>
                  {moment(data.created_at).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell>
                  <div>
                    <Button
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={(e) => {
                        handleClick(e);
                        setCurrentuserID(data.id);
                      }}
                    >
                      CHANGE
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={() => setAnchorEl(null)}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={() => changeAccess(2)}>
                        Super Admin
                      </MenuItem>
                      <MenuItem onClick={() => changeAccess(1)}>Admin</MenuItem>
                      <MenuItem onClick={() => changeAccess(0)}>User</MenuItem>
                    </Menu>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
